import { DataDictionaryViewReference } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams } from '@sonar-software/sonar-ts-types';

export type GetDataDictionaryViewReferencesRequest = DynamicQueryParams & KeyPaginationQueryParams;

export type GetDataDictionaryViewReferencesResponse = {
	customViews: DataDictionaryViewReference[];
};

export const getDataDictionaryViewReferences = createGetEndpoint<
	GetDataDictionaryViewReferencesRequest,
	GetDataDictionaryViewReferencesResponse
>((request) => `/api/v3/data-dictionary/views?${getQueryString(request)}`);
